import usePropertiesState from '@app/site/registration/fragment/state/PropertiesState';
import React from 'react';


const SetupPropertyDisplayFragment: React.FunctionComponent<{
	index: number,
	onEdit: (index: number) => any,
	onRemove: (index: number) => any,
	isProcessing: boolean
}> = ({ index, onEdit, onRemove, isProcessing }) => {
	const state = usePropertiesState();


	return !!state.properties[index].hotel ? <li className="flex justify-between gap-x-6 py-6">
		<div className="flex flex-col">
			<p className="text-base font-medium text-gray-800">
				{state.properties[index].hotel!.name}
			</p>
			<span
				className="text-sm text-gray-400">{state.properties[index].competitors!.length} Competitor{state.properties[index].competitors!.length > 1 ? 's' : ''}</span>
		</div>
		{!isProcessing && <div className="ml-4 flex flex-shrink-0 items-start space-x-4">
			<button className="font-semibold text-blue-600 hover:text-blue-500" onClick={() => onEdit(index)}>
				Edit
			</button>
			<span className="text-gray-300" aria-hidden="true">|</span>
			<button className="font-semibold text-blue-600 hover:text-blue-500" onClick={() => onRemove(index)}>
				Remove
			</button>
		</div>}
	</li> : <div />;
};

export default SetupPropertyDisplayFragment;